import './App.css';
// import FloatintButton from './components/FloatintButton';
// import { BrowserRouter } from 'react-router-dom';
import Home from './page/Home'

function App() {
  return (
    <div>
      {/* merci */}
      {/* <FloatintButton 
      company_name="Weetyu" 
      TCM_API_KEY="jamso20389732AI-AD" 
      message="This is a floating message!" 
      headerColor="#00f00f" 
      sendButtonColor="#0ffff6" 
      goToMessagePage={()=> {}}
      pageLink="/tcm-page"
      /> */}
      <Home />
    </div>
  );
}


export default App;
